'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Device = function (_React$PureComponent) {
  _inherits(Device, _React$PureComponent);

  function Device() {
    _classCallCheck(this, Device);

    return _possibleConstructorReturn(this, (Device.__proto__ || Object.getPrototypeOf(Device)).apply(this, arguments));
  }

  _createClass(Device, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: this.props.size,
          height: this.props.size,
          viewBox: '0 0 128 128'
        },
        _react2.default.createElement(
          'g',
          { fill: 'none', fillRule: 'evenodd', transform: 'translate(32 9)' },
          _react2.default.createElement('rect', {
            width: '64.769',
            height: '100.964',
            y: '9.493',
            fill: '#231F20',
            fillRule: 'nonzero',
            opacity: '.15',
            rx: '5.97'
          }),
          _react2.default.createElement('rect', {
            width: '64.769',
            height: '100.964',
            y: '4.741',
            fill: '#989EA0',
            fillRule: 'nonzero',
            rx: '5.97'
          }),
          _react2.default.createElement('rect', {
            width: '64.769',
            height: '100.964',
            fill: '#B7C1C4',
            fillRule: 'nonzero',
            rx: '5.97'
          }),
          _react2.default.createElement('rect', {
            width: '57.967',
            height: '88.354',
            x: '3.401',
            y: '3.923',
            fill: this.props.color,
            fillRule: 'nonzero',
            rx: '3.27'
          }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            d: 'M32.379 64.935c-8.164.112-14.88-6.402-15.016-14.565a3.958 3.958 0 0 1 7.905 0 7.111 7.111 0 0 0 14.222 0 3.958 3.958 0 0 1 7.905 0c-.137 8.163-6.852 14.677-15.016 14.565M43.46 43.306a3.994 3.994 0 0 1-2.761-1.102 3.71 3.71 0 0 1 0-5.345 3.982 3.982 0 0 1 5.51 0 3.698 3.698 0 0 1 0 5.345 3.994 3.994 0 0 1-2.76 1.102M21.262 43.306a3.994 3.994 0 0 1-2.762-1.102 3.71 3.71 0 0 1 0-5.345 3.994 3.994 0 0 1 5.523 0 3.71 3.71 0 0 1 0 5.345 3.994 3.994 0 0 1-2.761 1.102'
          }),
          _react2.default.createElement('path', {
            fill: '#707577',
            d: 'M39.11 98.274H25.67a1.86 1.86 0 0 1 0-3.71h13.44a1.86 1.86 0 0 1 0 3.71'
          }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            fillRule: 'nonzero',
            d: 'M57.931 12.527c-.655 0-1.185-.53-1.185-1.185 0-1.66-.77-2.489-2.3-2.489a1.185 1.185 0 1 1 0-2.37 4.468 4.468 0 0 1 4.67 4.859 1.185 1.185 0 0 1-1.185 1.185z',
            opacity: '.5'
          }),
          _react2.default.createElement('path', { fill: '#231F20', fillRule: 'nonzero', d: 'M34.382 7.656H49.22' }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            fillRule: 'nonzero',
            d: 'M49.22 8.841H34.37a1.185 1.185 0 1 1 0-2.37h14.85a1.185 1.185 0 0 1 0 2.37z',
            opacity: '.3'
          }),
          _react2.default.createElement('path', { fill: '#231F20', fillRule: 'nonzero', d: 'M57.931 30.27V16.615' }),
          _react2.default.createElement('path', {
            fill: '#FFF',
            fillRule: 'nonzero',
            d: 'M57.931 31.454c-.655 0-1.185-.53-1.185-1.185V16.592a1.185 1.185 0 0 1 2.37 0V30.27c0 .655-.53 1.185-1.185 1.185z',
            opacity: '.3'
          })
        )
      );
    }
  }]);

  return Device;
}(_react2.default.PureComponent);

Device.defaultProps = {
  size: 64,
  color: '#7A7ACE'
};

Device.propTypes = {
  size: _propTypes2.default.number,
  color: _propTypes2.default.string
};

exports.default = Device;